import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-08a98831"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "padding-top-32 footer-container"
};
const _hoisted_2 = {
  class: "text-center logo-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "flex justify-center align-items-center m-t-16 outer-links-box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "m-l-16 m-r-16 split-line"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "m-l-16 m-r-16 split-line"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "m-l-16 m-r-16 split-line"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "m-l-16 m-r-16 split-line"
}, null, -1));
const _hoisted_10 = {
  class: "m-t-16 text-center copyright-box"
};
import logo from "@/assets/img/logo.png";
import startrailLogo from "@/assets/img/pc-first/startrail-logo.png";
import { useI18n } from "vue-i18n";
import { ref, onMounted, onBeforeUnmount } from "vue";
export default {
  __name: 'FooterView',
  setup(__props) {
    const {
      locale,
      t
    } = useI18n();
    const showAddHome = ref(false);
    const addToHomeTimer = ref();
    const judgeAddToHome = () => {
      if (window.addToHome) {
        showAddHome.value = true;
      } else {
        addToHomeTimer.value = setInterval(() => {
          if (window.addToHome) {
            showAddHome.value = true;
            clearInterval(addToHomeTimer.value);
          }
        }, 500);
        addToHomeTimer.value && setTimeout(() => {
          clearInterval(addToHomeTimer.value);
        }, 5000);
      }
    };
    onMounted(() => {
      judgeAddToHome();
    });
    onBeforeUnmount(() => {
      addToHomeTimer.value && clearInterval(addToHomeTimer.value);
    });
    const openOuterLink = index => {
      switch (index) {
        case 0:
          window.top.open(process.env.VUE_APP_USE_STATUTE);
          break;
        case 1:
          if (locale.value === "ja") {
            window.top.open(process.env.VUE_APP_PRIVACY_POLICY_JA);
          } else {
            window.top.open(process.env.VUE_APP_PRIVACY_POLICY);
          }
          break;
        case 2:
          window.top.open(process.env.VUE_APP_FAQ);
          break;
        case 3:
          window.top.open(process.env.VUE_APP_TOKOSHOU_URL);
          break;
        case 4:
          if (locale.value === "ja") {
            window.top.open(process.env.VUE_APP_CONTACT_URL_JA);
          } else {
            window.top.open(process.env.VUE_APP_CONTACT_URL);
          }
          break;
        default:
          break;
      }
    };
    const addToHome = () => {
      if (window.deferredPrompt) {
        const deferredPrompt = window.deferredPrompt;
        deferredPrompt.prompt();
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("img", {
        class: "m-r-24",
        src: _unref(logo),
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: _unref(startrailLogo),
        alt: ""
      }, null, 8, _hoisted_4)]), _createElementVNode("section", _hoisted_5, [showAddHome.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", {
        class: "pointer link",
        onClick: addToHome
      }, _toDisplayString(_unref(t)("home.add_to_home_screen_label")), 1), _hoisted_6], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "pointer link",
        onClick: _cache[0] || (_cache[0] = $event => openOuterLink(4))
      }, _toDisplayString(_unref(t)("home.inquiry_label")), 1), _hoisted_7, _createElementVNode("span", {
        class: "pointer link",
        onClick: _cache[1] || (_cache[1] = $event => openOuterLink(0))
      }, _toDisplayString(_unref(t)("home.agreement_label")), 1), _hoisted_8, _createElementVNode("span", {
        class: "pointer link",
        onClick: _cache[2] || (_cache[2] = $event => openOuterLink(1))
      }, _toDisplayString(_unref(t)("home.privacy_policy_label")), 1), _hoisted_9, _createElementVNode("span", {
        class: "pointer link",
        onClick: _cache[3] || (_cache[3] = $event => openOuterLink(3))
      }, _toDisplayString(_unref(t)("home.specified_commercial_label")), 1)]), _createElementVNode("section", _hoisted_10, " ©" + _toDisplayString(new Date().getFullYear()) + " Startbahn, Inc. ", 1)]);
    };
  }
};